import { _ep0, _mw0, command } from "../commandBuilder";
import { GetRoleCredentials$ } from "../schemas/schemas_0";
export class GetRoleCredentialsCommand extends command(_ep0, _mw0, "GetRoleCredentials", GetRoleCredentials$) {
}
